import { render, staticRenderFns } from "./iSpringCommentView.vue?vue&type=template&id=d650662a&"
import script from "./iSpringCommentView.vue?vue&type=script&lang=js&"
export * from "./iSpringCommentView.vue?vue&type=script&lang=js&"
import style0 from "./iSpringCommentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports